import { Heading, HStack } from '@ayble-health/dashboard-components';
import React from 'react';
import { Spinner } from '@chakra-ui/react';

export const LoaderDefaultProps = {
  size: 'sm',
  label: 'Loading',
  color: 'cyan.500',
  headingColor: 'cyan.500',
  fontSize: 'sm',
  loading: false,
  p: 5
};

export const Loader = (props) => {
  const merged = { ...LoaderDefaultProps, ...props };

  return (
    <HStack gap={2} p={merged.p} my={props.my} justifyContent="center">
      <Spinner aria-label={merged.label} size={merged.size} color={merged.color} />
      {!props.noText && <Heading color={merged.headingColor} fontSize={merged.fontSize}>
        {merged.label}
      </Heading>}
    </HStack>
  );
};
